/**
 * Test IDs for QA automation.
 */
export const testIds = {
  forecastingModelSlotFormSalesAmount: "forecasting-model-slot-form-sales-amount",
} as const;
